var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_284_22",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.504225 0H17V17.88H0.504225V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_284_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6866 17.8717H2.81748C1.27528 17.8717 0.504177 17.3658 0.504177 16.354C0.504177 15.7343 0.693011 15.0735 1.07068 14.3716C1.44835 13.6696 1.99446 13.0073 2.7089 12.3844C3.42344 11.7615 4.28901 11.2541 5.3056 10.8619C6.3222 10.4698 7.46948 10.2738 8.74737 10.2738C10.0315 10.2738 11.1819 10.4698 12.1986 10.8619C13.2152 11.2541 14.0807 11.7615 14.7952 12.3844C15.5097 13.0073 16.0558 13.6696 16.4335 14.3716C16.8112 15.0735 17 15.7343 17 16.354C17 17.3658 16.2289 17.8717 14.6866 17.8717ZM15.1304 16.4394C15.2563 16.4394 15.346 16.4204 15.3995 16.3825C15.453 16.3445 15.4798 16.2749 15.4798 16.1738C15.4798 15.7881 15.3334 15.3406 15.0407 14.8316C14.748 14.3225 14.3152 13.8309 13.7424 13.3566C13.1695 12.8824 12.4645 12.4887 11.6273 12.1756C10.7901 11.8626 9.83009 11.7061 8.74737 11.7061C7.66467 11.7061 6.70625 11.8626 5.87211 12.1756C5.03806 12.4887 4.33464 12.8824 3.76176 13.3566C3.18896 13.8309 2.75618 14.3225 2.4634 14.8316C2.17072 15.3406 2.02433 15.7881 2.02433 16.1738C2.02433 16.2749 2.05112 16.3445 2.10459 16.3825C2.15815 16.4204 2.24469 16.4394 2.3643 16.4394H15.1304ZM8.74737 9.09767C7.99827 9.09767 7.3153 8.89531 6.69832 8.4906C6.08144 8.08588 5.5889 7.5468 5.22061 6.87333C4.85242 6.19987 4.66822 5.45527 4.66822 4.63952C4.66822 3.83011 4.85077 3.09814 5.21587 2.44364C5.58098 1.78915 6.07197 1.26903 6.68885 0.883298C7.30583 0.497557 7.99198 0.304688 8.74737 0.304688C9.49646 0.304688 10.1795 0.500719 10.7964 0.892782C11.4133 1.28485 11.9058 1.8097 12.2741 2.46736C12.6423 3.12502 12.8265 3.85539 12.8265 4.65849C12.8265 5.46791 12.6423 6.20936 12.2741 6.88282C11.9058 7.55629 11.4133 8.09379 10.7964 8.49534C10.1795 8.89689 9.49646 9.09767 8.74737 9.09767ZM8.74737 7.66537C9.20689 7.66537 9.63022 7.53099 10.0174 7.26224C10.4045 6.99349 10.7161 6.63146 10.9522 6.17616C11.1882 5.72086 11.3063 5.21496 11.3063 4.65849C11.3063 4.10834 11.1898 3.61351 10.9569 3.17403C10.724 2.73454 10.4139 2.38516 10.0268 2.12589C9.63967 1.86662 9.21319 1.73699 8.74737 1.73699C8.27525 1.73699 7.84562 1.86346 7.45849 2.1164C7.07135 2.36934 6.76282 2.71556 6.53308 3.15506C6.30335 3.59454 6.18848 4.08937 6.18848 4.63952C6.18848 5.196 6.30499 5.70346 6.53782 6.16193C6.77074 6.6204 7.08073 6.98558 7.46793 7.2575C7.85506 7.52941 8.28154 7.66537 8.74737 7.66537Z",
    fill: "#312E28"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 17 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.35f640fd64ea1c88e8f6130a0de38409.svg";
export { ForwardRef as ReactComponent };